// extracted by mini-css-extract-plugin
export default {"sideBurgerNav":"SideNavbar_sideBurgerNav__pz18V"};